import { render, staticRenderFns } from "./MsgRightItem.vue?vue&type=template&id=5ab8cec4&"
import script from "./MsgRightItem.vue?vue&type=script&lang=ts&"
export * from "./MsgRightItem.vue?vue&type=script&lang=ts&"
import style0 from "./MsgRightItem.vue?vue&type=style&index=0&id=5ab8cec4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports